module.exports = __webpack_public_path__ + "pin-red.ef2333ac65d8c0c85a79.svg";


//////////////////
// WEBPACK FOOTER
// C:/WORK/Projects/ActNow_NG2/src/styles/assets/pin-red.svg
// module id = ../../../../../src/styles/assets/pin-red.svg
// module chunks = styles